import { createSnackbarQueue } from '@rmwc/snackbar';

export const queue = createSnackbarQueue();

export default queue;
